import { render, staticRenderFns } from "./classify-add.vue?vue&type=template&id=047bb2d8&scoped=true&"
import script from "./classify-add.vue?vue&type=script&lang=js&"
export * from "./classify-add.vue?vue&type=script&lang=js&"
import style0 from "./classify-add.vue?vue&type=style&index=0&id=047bb2d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bb2d8",
  null
  
)

export default component.exports